/* Tailwind v4: single @import replaces @tailwind base/components/utilities */
@import 'tailwindcss';

/* ── Design tokens ──────────────────────────────────────────────────────────── */
:root {
  /* Colores base — TEMA CLARO (marca) */
  --color-bg:        #F4F6F8;   /* gris muy claro (fondo) */
  --color-surface:   #FFFFFF;   /* tarjetas */
  --color-surface-2: #EEF1F4;   /* inputs / zonas suaves */
  --color-border:    #DDE3EA;
  --color-border-2:  #C8D0DA;

  /* Texto */
  --color-text:      #1E232A;   /* Oxford (texto principal) */
  --color-text-2:    #5C6470;   /* Slate */
  --color-text-3:    #8A929C;   /* gris medio (secundario) */

  /* Acentos — Coral de marca */
  --color-accent:    #FF5E3A;   /* Coral */
  --color-accent-2:  #E54E2C;   /* Coral oscuro (hover) */
  --color-accent-dim:#FF9C88;   /* Coral claro (estados loading/disabled) */

  /* Semáforo (contraste sobre fondo claro) */
  --color-ok:        #15803d;
  --color-warn:      #b45309;
  --color-error:     #dc2626;
  --color-running:   #2563eb;

  /* Tipografía — Outfit (marca), Lato (cuerpo), DM Mono (cifras) */
  --font-ui:    'Lato', system-ui, sans-serif;
  --font-brand: 'Outfit', system-ui, sans-serif;
  --font-mono:  'DM Mono', 'Courier New', monospace;

  /* Sombras (suaves, para fondo claro) */
  --shadow-sm: 0 1px 2px rgba(16,24,40,0.06);
  --shadow-md: 0 4px 12px rgba(16,24,40,0.08);
  --shadow-lg: 0 8px 24px rgba(16,24,40,0.12);
}

/* ── Base ───────────────────────────────────────────────────────────────────── */
*, *::before, *::after { box-sizing: border-box; }

html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  font-family: var(--font-ui);
  background-color: var(--color-bg);
  color: var(--color-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* ── Scrollbar custom ────────────────────────────────────────────────────────── */
::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-track { background: var(--color-surface); }
::-webkit-scrollbar-thumb { background: var(--color-border-2); border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: var(--color-text-3); }

/* ── Mono numbers ────────────────────────────────────────────────────────────── */
.font-mono, code, .tabular-nums { font-family: var(--font-mono); }

/* ── Utility: fade-in ────────────────────────────────────────────────────────── */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}
.animate-fade-in { animation: fadeIn 0.2s ease-out forwards; }

/* ── Utility: pulse-dot (para running indicator) ─────────────────────────────── */
@keyframes pulseDot {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.3; }
}
.pulse-dot { animation: pulseDot 1.4s ease-in-out infinite; }
